<style lang="stylus">
    .leftpanel-search
        width 100%
        height 32px
        border 1px solid var(--border-color-gray2)
        border-radius 6px
        display flex
        align-items center
        padding-left 12px
        padding-right 8px
        input
            width 100%
            height 100%
            border none
            outline none
            background none
            font-size 12px
            line-height 14px
            color var(--text-color-primary)
            background-color var(--bg-color-primary)
            &::placeholder
                // color var(--placeholder-color)
                font-size 12px
                line-height 16px
        .search-icon
            width 17.5px
            height 16px
            cursor pointer
            color: var(--svg-color-primary);
        &:focus-within
            border-color var(--themeColor) !important
</style>

<template>
    <div class="leftpanel-search">
        <input
            ref="inputDom"
            type="text"
            :placeholder="placeholderStr || $t('searchPlaceholder')"
            :value="value"
            @input="changeInput"
            @keypress.enter="toSearch()"
        />
        <iconSymbol v-if="value" @click.native="clean" class="search-icon" name="clean-search-echart"></iconSymbol>
        <iconSymbol v-else @click.native="toSearch" class="search-icon" name="search-echart"></iconSymbol>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component
    export default class Search extends Vue {
        @Prop()
        value;
        @Prop()
        placeholderStr;
        changeInput() {
            let input = this.$refs.inputDom as HTMLInputElement;
            this.$emit("input", input.value);
        }
        toSearch() {
            this.$emit("toSearch");
        }
        clean() {
            this.$emit("input", "");
            this.$emit("toSearch");
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "searchPlaceholder": "请输入搜索内容"
    },
    "en": {
        "searchPlaceholder": "Please enter search content."
    },
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
